<script>
  import _ from 'underscore'
  import ItemPage from '../components/ItemPage.vue'
  import ItemList from '../components/ItemList.vue'
  import PageChooser from '../components/PageChooser.vue'
  import Status from '../components/Status.vue'
  import { item } from '../components/Item.vue'

  export default {
    components: { ItemPage, ItemList, PageChooser, Status },

    data () {
      return {
        date : '2021-05-04',
        major: [
          '2月チャンネル',
          '3月チャンネル',
          '共通',
        ],
        excepts: [
        ],
        items: [

          // [NOTE] KR
          // ================================================================================

          item({
            collection  : '2月チャンネル',
            id          : 'PCH6-01',
            rare        : 'KR',
            name        : 'アイランジュホワイトキラッとワンピ',
            imgUrl      : '/images/items/PCH6-01.png',
            kind        : 'ワンピース',
            color       : '白',
            brand       : 'PM',
            type        : 'PR',
            point       : 1900,
            numOwned    : { kira: 4 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '2月チャンネル',
            id          : 'PCH6-02',
            rare        : 'KR',
            name        : 'アイランジュホワイトキラッとシューズ',
            imgUrl      : '/images/items/PCH6-02.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'PM',
            type        : 'PR',
            point       : 1000,
            numOwned    : { kira: 3 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '2月チャンネル',
            id          : 'PCH6-03',
            rare        : 'KR',
            name        : 'アイランジュホワイトキラッとヘアアクセ',
            imgUrl      : '/images/items/PCH6-03.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : 'PM',
            type        : 'PR',
            point       : 900,
            numOwned    : { kira: 4 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '2月チャンネル',
            rare        : 'KR',
          }),


          item({
            collection  : '3月チャンネル',
            id          : 'P-046',
            rare        : 'KR',
            name        : 'アイランジュピンクキラッとワンピ',
            imgUrl      : '/images/items/P-046.png',
            kind        : 'ワンピース',
            color       : '桃',
            brand       : 'PM',
            type        : 'PR',
            point       : 1900,
            numOwned    : { kira: 0, usual: 1 },  // 第6弾では「あたり」で貰えるプロモチケ。キラチケは PAF03 の復刻チャンネルで排出される
            numReleased : { kira: 0, usual: 0 },  // 第6弾では「あたり」で貰えるプロモチケ。キラチケは PAF03 の復刻チャンネルで排出される
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '3月チャンネル',
            id          : 'P-047',
            rare        : 'KR',
            name        : 'アイランジュピンクキラッとシューズ',
            imgUrl      : '/images/items/P-047.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : 'PM',
            type        : 'PR',
            point       : 900,
            numOwned    : { kira: 3 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '3月チャンネル',
            id          : 'P-048',
            rare        : 'KR',
            name        : 'アイランジュピンクキラッとヘアアクセ',
            imgUrl      : '/images/items/P-048.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : 'PM',
            type        : 'PR',
            point       : 900,
            numOwned    : { kira: 0, usual: 1 },  // 第6弾では「あたり」で貰えるプロモチケ。キラチケは PAF03 の復刻チャンネルで排出される
            numReleased : { kira: 0, usual: 0 },  // 第6弾では「あたり」で貰えるプロモチケ。キラチケは PAF03 の復刻チャンネルで排出される
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '3月チャンネル',
            rare        : 'KR',
          }),


          item({
            collection  : '3月チャンネル',
            id          : 'PCH6-84',
            rare        : 'KR',
            name        : 'ピュアプリンセスホワイティキラッとワンピ',
            imgUrl      : '/images/items/PCH6-84.png',
            kind        : 'ワンピース',
            color       : '白',
            brand       : 'SH',
            type        : 'LO',
            point       : 1900,
            numOwned    : { kira: 4 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '3月チャンネル',
            id          : 'PCH6-85',
            rare        : 'KR',
            name        : 'ピュアプリンセスホワイティキラッとシューズ',
            imgUrl      : '/images/items/PCH6-85.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'SH',
            type        : 'LO',
            point       : 1000,
            numOwned    : { kira: 3 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '3月チャンネル',
            id          : 'PCH6-86',
            rare        : 'KR',
            name        : 'ピュアプリンセスホワイティキラッとヘアアクセ',
            imgUrl      : '/images/items/PCH6-86.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : 'SH',
            type        : 'LO',
            point       : 900,
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '3月チャンネル',
            rare        : 'KR',
          }),


          item({
            collection  : '3月チャンネル',
            id          : 'PCH6-87',
            rare        : 'KR',
            name        : 'ピュアプリンセスクリムゾンキラッとワンピ',
            imgUrl      : '/images/items/PCH6-87.png',
            kind        : 'ワンピース',
            color       : '赤',
            brand       : 'UQ',
            type        : 'CO',
            point       : 1900,
            numOwned    : { kira: 3 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '3月チャンネル',
            id          : 'PCH6-88',
            rare        : 'KR',
            name        : 'ピュアプリンセスクリムゾンキラッとシューズ',
            imgUrl      : '/images/items/PCH6-88.png',
            kind        : 'シューズ',
            color       : '赤',
            brand       : 'UQ',
            type        : 'CO',
            point       : 1000,
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '3月チャンネル',
            id          : 'PCH6-89',
            rare        : 'KR',
            name        : 'ピュアプリンセスクリムゾンキラッとヘアアクセ',
            imgUrl      : '/images/items/PCH6-89.png',
            kind        : 'ヘアアクセ',
            color       : '赤',
            brand       : 'UQ',
            type        : 'CO',
            point       : 900,
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '3月チャンネル',
            rare        : 'KR',
          }),


          // [NOTE] PR
          // ================================================================================

          item({
            collection  : '2月チャンネル',
            id          : 'PCH6-04',
            rare        : 'PR',
            name        : 'エンジェルナースブルートップス',
            imgUrl      : '/images/items/PCH6-04.png',
            kind        : 'トップス',
            color       : '水',
            brand       : 'SH',
            type        : 'LO',
            point       : 850,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '2月チャンネル',
            id          : 'PCH6-05',
            rare        : 'PR',
            name        : 'エンジェルナースブルースカート',
            imgUrl      : '/images/items/PCH6-05.png',
            kind        : 'ボトムス',
            color       : '水',
            brand       : 'SH',
            type        : 'LO',
            point       : 800,
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '2月チャンネル',
            id          : 'PCH6-06',
            rare        : 'PR',
            name        : 'エンジェルナースブルーシューズ',
            imgUrl      : '/images/items/PCH6-06.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'SH',
            type        : 'LO',
            point       : 750,
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '2月チャンネル',
            id          : 'PCH6-07',
            rare        : 'PR',
            name        : 'エンジェルナースブルーヘアアクセ',
            imgUrl      : '/images/items/PCH6-07.png',
            kind        : 'ヘアアクセ',
            color       : '水',
            brand       : 'SH',
            type        : 'LO',
            point       : 750,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : '2月チャンネル',
            id          : 'PCH6-08',
            rare        : 'PR',
            name        : 'スクール☆ガールレッドチェックトップス',
            imgUrl      : '/images/items/PCH6-08.png',
            kind        : 'トップス',
            color       : '青',
            brand       : 'GY',
            type        : 'PO',
            point       : 750,
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '2月チャンネル',
            id          : 'PCH6-09',
            rare        : 'PR',
            name        : 'スクール☆ガールレッドチェックスカート',
            imgUrl      : '/images/items/PCH6-09.png',
            kind        : 'ボトムス',
            color       : '赤',
            brand       : 'GY',
            type        : 'PO',
            point       : 850,
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '2月チャンネル',
            id          : 'PCH6-10',
            rare        : 'PR',
            name        : 'スクール☆ガールレッドチェックシューズ',
            imgUrl      : '/images/items/PCH6-10.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : 'GY',
            type        : 'PO',
            point       : 800,
            numOwned    : { kira: 1 },
            numReleased : { kira: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '2月チャンネル',
            id          : 'PCH6-11',
            rare        : 'PR',
            name        : 'スクール☆ガールレッドチェックヘアアクセ',
            imgUrl      : '/images/items/PCH6-11.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : 'GY',
            type        : 'PO',
            point       : 750,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : '3月チャンネル',
            id          : 'PCH6-90',
            rare        : 'PR',
            name        : 'もこもこモンスターパープルトップス',
            imgUrl      : '/images/items/PCH6-90.png',
            kind        : 'トップス',
            color       : '紫',
            brand       : 'UQ',
            type        : 'CO',
            point       : 850,
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '3月チャンネル',
            id          : 'PCH6-91',
            rare        : 'PR',
            name        : 'もこもこモンスターパープルスカート',
            imgUrl      : '/images/items/PCH6-91.png',
            kind        : 'ボトムス',
            color       : '紫',
            brand       : 'UQ',
            type        : 'CO',
            point       : 800,
            numOwned    : { kira: 3 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '3月チャンネル',
            id          : 'PCH6-92',
            rare        : 'PR',
            name        : 'もこもこモンスターパープルシューズ',
            imgUrl      : '/images/items/PCH6-92.png',
            kind        : 'シューズ',
            color       : '水',
            brand       : 'UQ',
            type        : 'CO',
            point       : 750,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : '3月チャンネル',
            id          : 'PCH6-93',
            rare        : 'PR',
            name        : 'もこもこモンスターパープルヘアアクセ',
            imgUrl      : '/images/items/PCH6-93.png',
            kind        : 'ヘアアクセ',
            color       : '紫',
            brand       : 'UQ',
            type        : 'CO',
            point       : 750,
            numOwned    : { kira: 4 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : '3月チャンネル',
            id          : 'PCH6-94',
            rare        : 'PR',
            name        : 'もこもこモンスターピンクトップス',
            imgUrl      : '/images/items/PCH6-94.png',
            kind        : 'トップス',
            color       : '桃',
            brand       : 'UQ',
            type        : 'CO',
            point       : 800,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '3月チャンネル',
            id          : 'PCH6-95',
            rare        : 'PR',
            name        : 'もこもこモンスターピンクスカート',
            imgUrl      : '/images/items/PCH6-95.png',
            kind        : 'ボトムス',
            color       : '桃',
            brand       : 'UQ',
            type        : 'CO',
            point       : 850,
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '3月チャンネル',
            id          : 'PCH6-96',
            rare        : 'PR',
            name        : 'もこもこモンスターピンクシューズ',
            imgUrl      : '/images/items/PCH6-96.png',
            kind        : 'シューズ',
            color       : '黄',
            brand       : 'UQ',
            type        : 'CO',
            point       : 750,
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '3月チャンネル',
            id          : 'PCH6-97',
            rare        : 'PR',
            name        : 'もこもこモンスターピンクヘアアクセ',
            imgUrl      : '/images/items/PCH6-97.png',
            kind        : 'ヘアアクセ',
            color       : '赤',
            brand       : 'UQ',
            type        : 'CO',
            point       : 750,
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] PR モーリーファンタジー限定
          // ================================================================================

          item({
            collection  : 'モーリーファンタジー限定',
            id          : 'MF-09',
            rare        : 'PR',
            name        : 'エンジェルナースグリーントップス',
            imgUrl      : '/images/items/MF-09.png',
            kind        : 'トップス',
            color       : '緑',
            brand       : 'SH',
            type        : 'LO',
            point       : 850,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: true,
          }),
          item({
            collection  : 'モーリーファンタジー限定',
            id          : 'MF-10',
            rare        : 'PR',
            name        : 'エンジェルナースグリーンスカート',
            imgUrl      : '/images/items/MF-10.png',
            kind        : 'ボトムス',
            color       : '緑',
            brand       : 'SH',
            type        : 'LO',
            point       : 800,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: true,
          }),
          item({
            collection  : 'モーリーファンタジー限定',
            id          : 'MF-11',
            rare        : 'PR',
            name        : 'エンジェルナースグリーンシューズ',
            imgUrl      : '/images/items/MF-11.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'SH',
            type        : 'LO',
            point       : 850,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: true,
          }),
          item({
            collection  : 'モーリーファンタジー限定',
            id          : 'MF-12',
            rare        : 'PR',
            name        : 'エンジェルナースグリーンヘアアクセ',
            imgUrl      : '/images/items/MF-12.png',
            kind        : 'ヘアアクセ',
            color       : '緑',
            brand       : 'SH',
            type        : 'LO',
            point       : 750,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: true,
          }),


          // [NOTE] SR
          // ================================================================================

          item({
            collection  : '2月チャンネル',
            id          : 'PCH6-12',
            rare        : 'SR',
            name        : 'エンジェルナースパープルトップス',
            imgUrl      : '/images/items/PCH6-12.png',
            kind        : 'トップス',
            color       : '紫',
            brand       : 'SH',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '2月チャンネル',
            id          : 'PCH6-13',
            rare        : 'SR',
            name        : 'エンジェルナースパープルスカート',
            imgUrl      : '/images/items/PCH6-13.png',
            kind        : 'ボトムス',
            color       : '紫',
            brand       : 'SH',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '2月チャンネル',
            id          : 'PCH6-14',
            rare        : 'SR',
            name        : 'エンジェルナースパープルシューズ',
            imgUrl      : '/images/items/PCH6-14.png',
            kind        : 'シューズ',
            color       : '紫',
            brand       : 'SH',
            type        : 'LO',
            point       : 600,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '2月チャンネル',
            id          : 'PCH6-15',
            rare        : 'SR',
            name        : 'エンジェルナースパープルヘアアクセ',
            imgUrl      : '/images/items/PCH6-15.png',
            kind        : 'ヘアアクセ',
            color       : '紫',
            brand       : 'SH',
            type        : 'LO',
            point       : 600,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : '2月チャンネル',
            id          : 'PCH6-16',
            rare        : 'SR',
            name        : 'スクール☆ガールブルーチェックトップス',
            imgUrl      : '/images/items/PCH6-16.png',
            kind        : 'トップス',
            color       : '白',
            brand       : 'GY',
            type        : 'PO',
            point       : 650,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '2月チャンネル',
            id          : 'PCH6-17',
            rare        : 'SR',
            name        : 'スクール☆ガールブルーチェックスカート',
            imgUrl      : '/images/items/PCH6-17.png',
            kind        : 'ボトムス',
            color       : '水',
            brand       : 'GY',
            type        : 'PO',
            point       : 600,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '2月チャンネル',
            id          : 'PCH6-18',
            rare        : 'SR',
            name        : 'スクール☆ガールブルーチェックシューズ',
            imgUrl      : '/images/items/PCH6-18.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'GY',
            type        : 'PO',
            point       : 700,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '2月チャンネル',
            id          : 'PCH6-19',
            rare        : 'SR',
            name        : 'スクール☆ガールブルーチェックヘアアクセ',
            imgUrl      : '/images/items/PCH6-19.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : 'GY',
            type        : 'PO',
            point       : 600,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : '2月チャンネル',
            id          : 'PCH6-20',
            rare        : 'SR',
            name        : 'チョコホイップジャムトップス',
            imgUrl      : '/images/items/PCH6-20.png',
            kind        : 'トップス',
            color       : '赤',
            brand       : 'SH',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 3 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '2月チャンネル',
            id          : 'PCH6-21',
            rare        : 'SR',
            name        : 'チョコホイップジャムスカート',
            imgUrl      : '/images/items/PCH6-21.png',
            kind        : 'ボトムス',
            color       : '赤',
            brand       : 'SH',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '2月チャンネル',
            id          : 'PCH6-22',
            rare        : 'SR',
            name        : 'チョコホイップジャムシューズ',
            imgUrl      : '/images/items/PCH6-22.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'SH',
            type        : 'LO',
            point       : 600,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '2月チャンネル',
            id          : 'PCH6-23',
            rare        : 'SR',
            name        : 'チョコホイップジャムヘアアクセ',
            imgUrl      : '/images/items/PCH6-23.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : 'SH',
            type        : 'LO',
            point       : 600,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : '2月チャンネル',
            id          : 'P-043',
            rare        : 'SR',
            name        : 'ねこうらないしブルーワンピ',
            imgUrl      : '//via.placeholder.com/100/fff/666/?text=P-043',
            kind        : 'ワンピース',
            color       : '青',
            brand       : 'UQ',
            type        : 'CO',
            point       : 1300,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '2月チャンネル',
            id          : 'P-044',
            rare        : 'SR',
            name        : 'ねこうらないしブルーシューズ',
            imgUrl      : '//via.placeholder.com/100/fff/666/?text=P-044',
            kind        : 'シューズ',
            color       : '黒',
            brand       : 'UQ',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '2月チャンネル',
            id          : 'P-045',
            rare        : 'SR',
            name        : 'ねこうらないしブルーヘアアクセ',
            imgUrl      : '/images/items/P-045.png',
            kind        : 'ヘアアクセ',
            color       : '青',
            brand       : 'UQ',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '2月チャンネル',
            rare        : 'SR',
          }),


          item({
            collection  : '3月チャンネル',
            id          : 'PCH6-98',
            rare        : 'SR',
            name        : 'ホワイトデーラブミントトップス',
            imgUrl      : '/images/items/PCH6-98.png',
            kind        : 'トップス',
            color       : '水',
            brand       : 'DW',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 10 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '3月チャンネル',
            id          : 'PCH6-99',
            rare        : 'SR',
            name        : 'ホワイトデーラブミントスカート',
            imgUrl      : '/images/items/PCH6-99.png',
            kind        : 'ボトムス',
            color       : '水',
            brand       : 'DW',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '3月チャンネル',
            id          : 'PCH6-100',
            rare        : 'SR',
            name        : 'ホワイトデーラブミントシューズ',
            imgUrl      : '/images/items/PCH6-100.png',
            kind        : 'シューズ',
            color       : '水',
            brand       : 'DW',
            type        : 'LO',
            point       : 600,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '3月チャンネル',
            id          : 'PCH6-101',
            rare        : 'SR',
            name        : 'ホワイトデーラブミントヘアアクセ',
            imgUrl      : '/images/items/PCH6-101.png',
            kind        : 'ヘアアクセ',
            color       : '水',
            brand       : 'DW',
            type        : 'LO',
            point       : 600,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : '3月チャンネル',
            id          : 'PCH6-102',
            rare        : 'SR',
            name        : 'チョコホイップオレンジトップス',
            imgUrl      : '/images/items/PCH6-102.png',
            kind        : 'トップス',
            color       : '橙',
            brand       : 'SH',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '3月チャンネル',
            id          : 'PCH6-103',
            rare        : 'SR',
            name        : 'チョコホイップオレンジスカート',
            imgUrl      : '/images/items/PCH6-103.png',
            kind        : 'ボトムス',
            color       : '橙',
            brand       : 'SH',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '3月チャンネル',
            id          : 'PCH6-104',
            rare        : 'SR',
            name        : 'チョコホイップオレンジシューズ',
            imgUrl      : '/images/items/PCH6-104.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'SH',
            type        : 'LO',
            point       : 600,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '3月チャンネル',
            id          : 'PCH6-105',
            rare        : 'SR',
            name        : 'チョコホイップオレンジヘアアクセ',
            imgUrl      : '/images/items/PCH6-105.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : 'SH',
            type        : 'LO',
            point       : 600,
            numOwned    : { usual: 9 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : '3月チャンネル',
            id          : 'PCH6-106',
            rare        : 'SR',
            name        : 'チョコホイップサワートップス',
            imgUrl      : '/images/items/PCH6-106.png',
            kind        : 'トップス',
            color       : '水',
            brand       : 'SH',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 7 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '3月チャンネル',
            id          : 'PCH6-107',
            rare        : 'SR',
            name        : 'チョコホイップサワースカート',
            imgUrl      : '/images/items/PCH6-107.png',
            kind        : 'ボトムス',
            color       : '水',
            brand       : 'SH',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '3月チャンネル',
            id          : 'PCH6-108',
            rare        : 'SR',
            name        : 'チョコホイップサワーシューズ',
            imgUrl      : '/images/items/PCH6-108.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'SH',
            type        : 'LO',
            point       : 600,
            numOwned    : { usual: 8 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '3月チャンネル',
            id          : 'PCH6-109',
            rare        : 'SR',
            name        : 'チョコホイップサワーヘアアクセ',
            imgUrl      : '/images/items/PCH6-109.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : 'SH',
            type        : 'LO',
            point       : 600,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] R
          // ================================================================================

          item({
            collection  : '共通',
            id          : 'PCH6-25',
            rare        : 'R',
            name        : 'ティーカップメルヘンリメイクブルートップス',
            imgUrl      : '/images/items/PCH6-25.png',
            kind        : 'トップス',
            color       : '水',
            brand       : 'SH',
            type        : 'LO',
            point       : 550,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'PCH6-26',
            rare        : 'R',
            name        : 'ティーカップメルヘンリメイクブルースカート',
            imgUrl      : '/images/items/PCH6-26.png',
            kind        : 'ボトムス',
            color       : '水',
            brand       : 'SH',
            type        : 'LO',
            point       : 500,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'PCH6-27',
            rare        : 'R',
            name        : 'ティーカップメルヘンリメイクブルーシューズ',
            imgUrl      : '/images/items/PCH6-27.png',
            kind        : 'シューズ',
            color       : '水',
            brand       : 'SH',
            type        : 'LO',
            point       : 450,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'PCH6-28',
            rare        : 'R',
            name        : 'ティーカップメルヘンリメイクブルーヘアアクセ',
            imgUrl      : '/images/items/PCH6-28.png',
            kind        : 'ヘアアクセ',
            color       : '黒',
            brand       : 'SH',
            type        : 'LO',
            point       : 450,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : '共通',
            id          : 'PCH6-29',
            rare        : 'R',
            name        : 'ティーカップメルヘンリメイクピンクトップス',
            imgUrl      : '/images/items/PCH6-29.png',
            kind        : 'トップス',
            color       : '桃',
            brand       : 'SH',
            type        : 'LO',
            point       : 450,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'PCH6-30',
            rare        : 'R',
            name        : 'ティーカップメルヘンリメイクピンクスカート',
            imgUrl      : '/images/items/PCH6-30.png',
            kind        : 'ボトムス',
            color       : '桃',
            brand       : 'SH',
            type        : 'LO',
            point       : 550,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'PCH6-31',
            rare        : 'R',
            name        : 'ティーカップメルヘンリメイクピンクシューズ',
            imgUrl      : '/images/items/PCH6-31.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : 'SH',
            type        : 'LO',
            point       : 500,
            numOwned    : { usual: 8 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'PCH6-32',
            rare        : 'R',
            name        : 'ティーカップメルヘンリメイクピンクヘアアクセ',
            imgUrl      : '/images/items/PCH6-32.png',
            kind        : 'ヘアアクセ',
            color       : '黒',
            brand       : 'SH',
            type        : 'LO',
            point       : 450,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : '共通',
            id          : 'PCH6-33',
            rare        : 'R',
            name        : 'ガーデンフラワーグリーントップス',
            imgUrl      : '/images/items/PCH6-33.png',
            kind        : 'トップス',
            color       : '緑',
            brand       : 'PM',
            type        : 'PR',
            point       : 550,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'PCH6-34',
            rare        : 'R',
            name        : 'ガーデンフラワーグリーンスカート',
            imgUrl      : '/images/items/PCH6-34.png',
            kind        : 'ボトムス',
            color       : '緑',
            brand       : 'PM',
            type        : 'PR',
            point       : 450,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'PCH6-35',
            rare        : 'R',
            name        : 'ガーデンフラワーグリーンシューズ',
            imgUrl      : '/images/items/PCH6-35.png',
            kind        : 'シューズ',
            color       : '緑',
            brand       : 'PM',
            type        : 'PR',
            point       : 500,
            numOwned    : { usual: 7 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'PCH6-36',
            rare        : 'R',
            name        : 'ガーデンフラワーグリーンヘアアクセ',
            imgUrl      : '/images/items/PCH6-36.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : 'PM',
            type        : 'PR',
            point       : 450,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : '共通',
            id          : 'PCH6-37',
            rare        : 'R',
            name        : 'トランプディーラーワインレッドトップス',
            imgUrl      : '/images/items/PCH6-37.png',
            kind        : 'トップス',
            color       : '赤',
            brand       : 'SA',
            type        : 'CO',
            point       : 550,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'PCH6-38',
            rare        : 'R',
            name        : 'トランプディーラーワインレッドスカート',
            imgUrl      : '/images/items/PCH6-38.png',
            kind        : 'ボトムス',
            color       : '赤',
            brand       : 'SA',
            type        : 'CO',
            point       : 500,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'PCH6-39',
            rare        : 'R',
            name        : 'トランプディーラーワインレッドシューズ',
            imgUrl      : '/images/items/PCH6-39.png',
            kind        : 'シューズ',
            color       : '赤',
            brand       : 'SA',
            type        : 'CO',
            point       : 450,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'PCH6-40',
            rare        : 'R',
            name        : 'トランプディーラーワインレッドヘアアクセ',
            imgUrl      : '/images/items/PCH6-40.png',
            kind        : 'ヘアアクセ',
            color       : '赤',
            brand       : 'SA',
            type        : 'CO',
            point       : 450,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] N
          // ================================================================================

          item({
            collection  : '共通',
            id          : 'PCH6-41',
            rare        : 'N',
            name        : 'ウィンターファーピンクワンピ',
            imgUrl      : '/images/items/PCH6-41.png',
            kind        : 'ワンピース',
            color       : '桃',
            brand       : 'SH',
            type        : 'LO',
            point       : 600,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'PCH6-42',
            rare        : 'N',
            name        : 'ウィンターファーピンクシューズ',
            imgUrl      : '/images/items/PCH6-42.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : 'SH',
            type        : 'LO',
            point       : 300,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'PCH6-43',
            rare        : 'N',
            name        : 'ウィンターファーピンクヘアアクセ',
            imgUrl      : '/images/items/PCH6-43.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : 'SH',
            type        : 'LO',
            point       : 300,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            rare        : 'N',
          }),


          item({
            collection  : '共通',
            id          : 'PCH6-44',
            rare        : 'N',
            name        : 'クラシックハートレッドトップス',
            imgUrl      : '/images/items/PCH6-44.png',
            kind        : 'トップス',
            color       : '黒',
            brand       : 'UQ',
            type        : 'CO',
            point       : 400,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'PCH6-45',
            rare        : 'N',
            name        : 'クラシックハートレッドスカート',
            imgUrl      : '/images/items/PCH6-45.png',
            kind        : 'ボトムス',
            color       : '赤',
            brand       : 'UQ',
            type        : 'CO',
            point       : 350,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'PCH6-46',
            rare        : 'N',
            name        : 'クラシックハートレッドシューズ',
            imgUrl      : '/images/items/PCH6-46.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : 'UQ',
            type        : 'CO',
            point       : 300,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'PCH6-47',
            rare        : 'N',
            name        : 'クラシックハートレッドヘアアクセ',
            imgUrl      : '/images/items/PCH6-47.png',
            kind        : 'ヘアアクセ',
            color       : '赤',
            brand       : 'UQ',
            type        : 'CO',
            point       : 300,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : '共通',
            id          : 'PCH6-48',
            rare        : 'N',
            name        : 'たんていボーイブルートップス',
            imgUrl      : '/images/items/PCH6-48.png',
            kind        : 'トップス',
            color       : '白',
            brand       : 'GY',
            type        : 'PO',
            point       : 350,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'PCH6-49',
            rare        : 'N',
            name        : 'たんていボーイブルーパンツ',
            imgUrl      : '/images/items/PCH6-49.png',
            kind        : 'ボトムス',
            color       : '水',
            brand       : 'GY',
            type        : 'PO',
            point       : 300,
            numOwned    : { usual: 8 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'PCH6-50',
            rare        : 'N',
            name        : 'たんていボーイブルーシューズ',
            imgUrl      : '/images/items/PCH6-50.png',
            kind        : 'シューズ',
            color       : '茶',
            brand       : 'GY',
            type        : 'PO',
            point       : 400,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'PCH6-51',
            rare        : 'N',
            name        : 'たんていボーイブルーヘアアクセ',
            imgUrl      : '/images/items/PCH6-51.png',
            kind        : 'ヘアアクセ',
            color       : '水',
            brand       : 'GY',
            type        : 'PO',
            point       : 300,
            numOwned    : { usual: 8 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : '共通',
            id          : 'PCH6-52',
            rare        : 'N',
            name        : 'ニュースペーパーダンスジャケット',
            imgUrl      : '/images/items/PCH6-52.png',
            kind        : 'トップス',
            color       : '白',
            brand       : 'RB',
            type        : 'CO',
            point       : 400,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'PCH6-53',
            rare        : 'N',
            name        : 'ニュースペーパーダンスパンツ',
            imgUrl      : '/images/items/PCH6-53.png',
            kind        : 'ボトムス',
            color       : '緑',
            brand       : 'RB',
            type        : 'CO',
            point       : 300,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'PCH6-54',
            rare        : 'N',
            name        : 'ニュースペーパーダンスシューズ',
            imgUrl      : '/images/items/PCH6-54.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'RB',
            type        : 'CO',
            point       : 350,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'PCH6-55',
            rare        : 'N',
            name        : 'ニュースペーパーダンスヘアアクセ',
            imgUrl      : '/images/items/PCH6-55.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : 'RB',
            type        : 'CO',
            point       : 300,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : '共通',
            id          : 'PCH6-56',
            rare        : 'N',
            name        : 'レーシーブルートップス',
            imgUrl      : '/images/items/PCH6-56.png',
            kind        : 'トップス',
            color       : '白',
            brand       : 'DW',
            type        : 'LO',
            point       : 400,
            numOwned    : { usual: 7 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'PCH6-57',
            rare        : 'N',
            name        : 'レーシーブルースカート',
            imgUrl      : '/images/items/PCH6-57.png',
            kind        : 'ボトムス',
            color       : '青',
            brand       : 'DW',
            type        : 'LO',
            point       : 350,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'PCH6-58',
            rare        : 'N',
            name        : 'レーシーブルーシューズ',
            imgUrl      : '/images/items/PCH6-58.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'DW',
            type        : 'LO',
            point       : 300,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'PCH6-59',
            rare        : 'N',
            name        : 'レーシーブルーヘアアクセ',
            imgUrl      : '/images/items/PCH6-59.png',
            kind        : 'ヘアアクセ',
            color       : '青',
            brand       : 'DW',
            type        : 'LO',
            point       : 300,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : '共通',
            id          : 'PCH6-60',
            rare        : 'N',
            name        : 'ドレッシーレザーワンピ',
            imgUrl      : '/images/items/PCH6-60.png',
            kind        : 'ワンピース',
            color       : '黒',
            brand       : 'UQ',
            type        : 'CO',
            point       : 600,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'PCH6-61',
            rare        : 'N',
            name        : 'ドレッシーレザーシューズ',
            imgUrl      : '/images/items/PCH6-61.png',
            kind        : 'シューズ',
            color       : '紫',
            brand       : 'UQ',
            type        : 'CO',
            point       : 300,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'PCH6-62',
            rare        : 'N',
            name        : 'ドレッシーレザーヘアアクセ',
            imgUrl      : '/images/items/PCH6-62.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : 'UQ',
            type        : 'CO',
            point       : 300,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            rare        : 'N',
          }),


          // [NOTE] パシャッとアイテム
          // ================================================================================

          item({
            collection  : '2月チャンネル',
            id          : 'PCH6-24',
            rare        : 'SR',
            name        : 'バレンタインラブリーチョコ',
            imgUrl      : '/images/items/PCH6-24.png',
            kind        : 'パシャッとアイテム',
            color       : '赤',
            brand       : 'SH',
            type        : 'LO',
            point       : 600,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '2月チャンネル',
            kind        : 'パシャッとアイテム',
          }),
          item({
            collection  : '2月チャンネル',
            kind        : 'パシャッとアイテム',
          }),
          item({
            collection  : '2月チャンネル',
            kind        : 'パシャッとアイテム',
          }),


          item({
            collection  : '3月チャンネル',
            id          : 'PCH6-110',
            rare        : 'SR',
            name        : 'シュワシュワソーダ',
            imgUrl      : '/images/items/PCH6-110.png',
            kind        : 'パシャッとアイテム',
            color       : '赤',
            brand       : 'GY',
            type        : 'PO',
            point       : 600,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '3月チャンネル',
            kind        : 'パシャッとアイテム',
          }),
          item({
            collection  : '3月チャンネル',
            kind        : 'パシャッとアイテム',
          }),
          item({
            collection  : '3月チャンネル',
            kind        : 'パシャッとアイテム',
          }),


          item({
            collection  : '共通',
            id          : 'PCH6-63',
            rare        : 'R',
            name        : 'ホワイトフェザーペン',
            imgUrl      : '/images/items/PCH6-63.png',
            kind        : 'パシャッとアイテム',
            color       : '白',
            brand       : 'PM',
            type        : 'PR',
            point       : 450,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'PCH6-64',
            rare        : 'R',
            name        : 'キュートハブラシ',
            imgUrl      : '/images/items/PCH6-64.png',
            kind        : 'パシャッとアイテム',
            color       : '桃',
            brand       : 'GY',
            type        : 'PO',
            point       : 450,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'PCH6-65',
            rare        : 'R',
            name        : 'ビッグハンバーガー',
            imgUrl      : '/images/items/PCH6-65.png',
            kind        : 'パシャッとアイテム',
            color       : '茶',
            brand       : 'GY',
            type        : 'PO',
            point       : 450,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            kind        : 'パシャッとアイテム',
          }),


          // [NOTE] なかよしチャンネル
          // ================================================================================

          item({
            collection  : 'なかよしチャンネル',
            id          : 'PCH6-119',
            rare        : 'SR',
            name        : 'ホワイトデーラブリーチョコ',
            imgUrl      : '/images/items/PCH6-119.jpg',
            kind        : 'パシャッとアイテム',
            color       : '水',
            brand       : 'SH',
            type        : 'LO',
            point       : 550,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'なかよしチャンネル',
            rare        : 'SR',
          }),
          item({
            collection  : 'なかよしチャンネル',
            rare        : 'SR',
          }),
          item({
            collection  : 'なかよしチャンネル',
            rare        : 'SR',
          }),


          // [NOTE] 初音ミク復刻コラボ・リラックマコラボ
          // ================================================================================

          item({
            collection  : '初音ミク復刻コラボ・リラックマコラボ',
            id          : 'PCH6-74',
            rare        : 'SR',
            name        : 'はつねミクワンピ',
            imgUrl      : '/images/items/PCH6-74.png',
            kind        : 'ワンピース',
            color       : '銀',
            brand       : '',
            type        : 'PR',
            point       : 1200,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '初音ミク復刻コラボ・リラックマコラボ',
            id          : 'PCH6-75',
            rare        : 'SR',
            name        : 'はつねミクシューズ',
            imgUrl      : '/images/items/PCH6-75.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : '',
            type        : 'PR',
            point       : 600,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '初音ミク復刻コラボ・リラックマコラボ',
            id          : 'PCH6-76',
            rare        : 'SR',
            name        : 'はつねミクヘアアクセ',
            imgUrl      : '/images/items/PCH6-76.png',
            kind        : 'ヘアアクセ',
            color       : '黒',
            brand       : '',
            type        : 'PR',
            point       : 600,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '初音ミク復刻コラボ・リラックマコラボ',
            rare        : 'SR',
          }),


          item({
            collection  : '初音ミク復刻コラボ・リラックマコラボ',
            id          : 'PCH6-77',
            rare        : 'SR',
            name        : 'ゆきミクワンピ',
            imgUrl      : '/images/items/PCH6-77.png',
            kind        : 'ワンピース',
            color       : '白',
            brand       : '',
            type        : 'PR',
            point       : 1200,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '初音ミク復刻コラボ・リラックマコラボ',
            id          : 'PCH6-78',
            rare        : 'SR',
            name        : 'ゆきミクシューズ',
            imgUrl      : '/images/items/PCH6-78.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : '',
            type        : 'PR',
            point       : 600,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '初音ミク復刻コラボ・リラックマコラボ',
            id          : 'PCH6-79',
            rare        : 'SR',
            name        : 'ゆきミクヘアアクセ',
            imgUrl      : '/images/items/PCH6-79.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : '',
            type        : 'PR',
            point       : 600,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '初音ミク復刻コラボ・リラックマコラボ',
            rare        : 'SR',
          }),


          item({
            collection  : '初音ミク復刻コラボ・リラックマコラボ',
            id          : 'PCH6-80',
            rare        : 'SR',
            name        : 'リラックマパンケーキトップス',
            imgUrl      : '/images/items/PCH6-80.png',
            kind        : 'トップス',
            color       : '茶',
            brand       : '',
            type        : 'PR',
            point       : 700,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '初音ミク復刻コラボ・リラックマコラボ',
            id          : 'PCH6-81',
            rare        : 'SR',
            name        : 'リラックマパンケーキスカート',
            imgUrl      : '/images/items/PCH6-81.png',
            kind        : 'ボトムス',
            color       : '茶',
            brand       : '',
            type        : 'PR',
            point       : 650,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '初音ミク復刻コラボ・リラックマコラボ',
            id          : 'PCH6-82',
            rare        : 'SR',
            name        : 'リラックマパンケーキシューズ',
            imgUrl      : '/images/items/PCH6-82.png',
            kind        : 'シューズ',
            color       : '茶',
            brand       : '',
            type        : 'PR',
            point       : 600,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '初音ミク復刻コラボ・リラックマコラボ',
            id          : 'PCH6-83',
            rare        : 'SR',
            name        : 'リラックマパンケーキヘアアクセ',
            imgUrl      : '/images/items/PCH6-83.png',
            kind        : 'ヘアアクセ',
            color       : '茶',
            brand       : '',
            type        : 'PR',
            point       : 600,
            numOwned    : { usual: 7 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] バレンタインキャンペーン
          // ================================================================================

          item({
            collection  : 'バレンタインキャンペーン',
            id          : 'PCH6-66',
            rare        : 'SR',
            name        : 'ハートフルバレンタインレッドトップス',
            imgUrl      : '/images/items/PCH6-66.png',
            kind        : 'トップス',
            color       : '紫',
            brand       : 'SA',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'バレンタインキャンペーン',
            id          : 'PCH6-67',
            rare        : 'SR',
            name        : 'ハートフルバレンタインレッドスカート',
            imgUrl      : '/images/items/PCH6-67.png',
            kind        : 'ボトムス',
            color       : '赤',
            brand       : 'SA',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'バレンタインキャンペーン',
            id          : 'PCH6-68',
            rare        : 'SR',
            name        : 'ハートフルバレンタインレッドシューズ',
            imgUrl      : '/images/items/PCH6-68.png',
            kind        : 'シューズ',
            color       : '茶',
            brand       : 'SA',
            type        : 'CO',
            point       : 600,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'バレンタインキャンペーン',
            id          : 'PCH6-69',
            rare        : 'SR',
            name        : 'ハートフルバレンタインレッドヘアアクセ',
            imgUrl      : '/images/items/PCH6-69.png',
            kind        : 'ヘアアクセ',
            color       : '赤',
            brand       : 'SA',
            type        : 'CO',
            point       : 600,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'バレンタインキャンペーン',
            id          : 'PCH6-70',
            rare        : 'SR',
            name        : 'ハートフルバレンタインパープルトップス',
            imgUrl      : '/images/items/PCH6-70.png',
            kind        : 'トップス',
            color       : '茶',
            brand       : 'SA',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'バレンタインキャンペーン',
            id          : 'PCH6-71',
            rare        : 'SR',
            name        : 'ハートフルバレンタインパープルスカート',
            imgUrl      : '/images/items/PCH6-71.png',
            kind        : 'ボトムス',
            color       : '紫',
            brand       : 'SA',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'バレンタインキャンペーン',
            id          : 'PCH6-72',
            rare        : 'SR',
            name        : 'ハートフルバレンタインパープルシューズ',
            imgUrl      : '/images/items/PCH6-72.png',
            kind        : 'シューズ',
            color       : '茶',
            brand       : 'SA',
            type        : 'CO',
            point       : 600,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'バレンタインキャンペーン',
            id          : 'PCH6-73',
            rare        : 'SR',
            name        : 'ハートフルバレンタインパープルヘアアクセ',
            imgUrl      : '/images/items/PCH6-73.png',
            kind        : 'ヘアアクセ',
            color       : '紫',
            brand       : 'SA',
            type        : 'CO',
            point       : 600,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] ホワイトデーキャンペーン
          // ================================================================================

          item({
            collection  : 'ホワイトデーキャンペーン',
            id          : 'PCH6-111',
            rare        : 'SR',
            name        : 'ホワイトデーラブピンクトップス',
            imgUrl      : '/images/items/PCH6-111.png',
            kind        : 'トップス',
            color       : '桃',
            brand       : 'DW',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ホワイトデーキャンペーン',
            id          : 'PCH6-112',
            rare        : 'SR',
            name        : 'ホワイトデーラブピンクスカート',
            imgUrl      : '/images/items/PCH6-112.png',
            kind        : 'ボトムス',
            color       : '桃',
            brand       : 'DW',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ホワイトデーキャンペーン',
            id          : 'PCH6-113',
            rare        : 'SR',
            name        : 'ホワイトデーラブピンクシューズ',
            imgUrl      : '/images/items/PCH6-113.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : 'DW',
            type        : 'LO',
            point       : 600,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ホワイトデーキャンペーン',
            id          : 'PCH6-114',
            rare        : 'SR',
            name        : 'ホワイトデーラブピンクヘアアクセ',
            imgUrl      : '/images/items/PCH6-114.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : 'DW',
            type        : 'LO',
            point       : 600,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'ホワイトデーキャンペーン',
            id          : 'PCH6-115',
            rare        : 'SR',
            name        : 'ホワイトデーラブパープルトップス',
            imgUrl      : '/images/items/PCH6-115.png',
            kind        : 'トップス',
            color       : '紫',
            brand       : 'DW',
            type        : 'LO',
            point       : 600,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ホワイトデーキャンペーン',
            id          : 'PCH6-116',
            rare        : 'SR',
            name        : 'ホワイトデーラブパープルスカート',
            imgUrl      : '/images/items/PCH6-116.png',
            kind        : 'ボトムス',
            color       : '紫',
            brand       : 'DW',
            type        : 'LO',
            point       : 750,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ホワイトデーキャンペーン',
            id          : 'PCH6-117',
            rare        : 'SR',
            name        : 'ホワイトデーラブパープルシューズ',
            imgUrl      : '/images/items/PCH6-117.png',
            kind        : 'シューズ',
            color       : '紫',
            brand       : 'DW',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ホワイトデーキャンペーン',
            id          : 'PCH6-118',
            rare        : 'SR',
            name        : 'ホワイトデーラブパープルヘアアクセ',
            imgUrl      : '/images/items/PCH6-118.png',
            kind        : 'ヘアアクセ',
            color       : '紫',
            brand       : 'DW',
            type        : 'LO',
            point       : 600,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] ネクスト・プリンセス・スペシャル大会
          // ================================================================================

          item({
            collection  : 'ネクスト・プリンセス・スペシャル大会',
            id          : 'SP-017',
            rare        : 'SR',
            name        : 'プリティーリボンパステルミントトップス',
            imgUrl      : '/images/items/SP-017.png',
            kind        : 'トップス',
            color       : '水',
            brand       : 'SH',
            type        : 'LO',
            point       : 800,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ネクスト・プリンセス・スペシャル大会',
            id          : 'SP-018',
            rare        : 'SR',
            name        : 'プリティーリボンパステルミントスカート',
            imgUrl      : '/images/items/SP-018.png',
            kind        : 'ボトムス',
            color       : '水',
            brand       : 'SH',
            type        : 'LO',
            point       : 750,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ネクスト・プリンセス・スペシャル大会',
            id          : 'SP-019',
            rare        : 'SR',
            name        : 'プリティーリボンパステルミントシューズ',
            imgUrl      : '/images/items/SP-019.png',
            kind        : 'シューズ',
            color       : '水',
            brand       : 'SH',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ネクスト・プリンセス・スペシャル大会',
            id          : 'SP-020',
            rare        : 'SR',
            name        : 'プリティーリボンパステルミントヘアアクセ',
            imgUrl      : '/images/items/SP-020.png',
            kind        : 'ヘアアクセ',
            color       : '水',
            brand       : 'SH',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'ネクスト・プリンセス・スペシャル大会',
            id          : 'SP-021',
            rare        : 'SR',
            name        : 'ファンキーファーライラックトップス',
            imgUrl      : '/images/items/SP-021.png',
            kind        : 'トップス',
            color       : '桃',
            brand       : 'UQ',
            type        : 'CO',
            point       : 800,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ネクスト・プリンセス・スペシャル大会',
            id          : 'SP-022',
            rare        : 'SR',
            name        : 'ファンキーファーライラックスカート',
            imgUrl      : '/images/items/SP-022.png',
            kind        : 'ボトムス',
            color       : '桃',
            brand       : 'UQ',
            type        : 'CO',
            point       : 750,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ネクスト・プリンセス・スペシャル大会',
            id          : 'SP-023',
            rare        : 'SR',
            name        : 'ファンキーファーライラックシューズ',
            imgUrl      : '/images/items/SP-023.png',
            kind        : 'シューズ',
            color       : '緑',
            brand       : 'UQ',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ネクスト・プリンセス・スペシャル大会',
            id          : 'SP-024',
            rare        : 'SR',
            name        : 'ファンキーファーライラックヘアアクセ',
            imgUrl      : '/images/items/SP-024.png',
            kind        : 'ヘアアクセ',
            color       : '紫',
            brand       : 'UQ',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] ファララチャンネル
          // ================================================================================

          item({
            collection  : 'ファララチャンネル',
            id          : 'SL6-36',
            rare        : 'SR',
            name        : 'アイドルウォッチエメラルドドレス',
            imgUrl      : '/images/items/SL6-36.png',
            kind        : 'ワンピース',
            color       : '緑',
            brand       : '',
            type        : 'PO',
            point       : 1200,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ファララチャンネル',
            id          : 'SL6-37',
            rare        : 'SR',
            name        : 'アイドルウォッチエメラルドシューズ',
            imgUrl      : '/images/items/SL6-37.png',
            kind        : 'シューズ',
            color       : '金',
            brand       : '',
            type        : 'PO',
            point       : 600,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ファララチャンネル',
            id          : 'SL6-38',
            rare        : 'SR',
            name        : 'アイドルウォッチエメラルドヘアアクセ',
            imgUrl      : '/images/items/SL6-38.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : '',
            type        : 'PO',
            point       : 600,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ファララチャンネル',
          }),


          item({
            collection  : 'ファララチャンネル',
            id          : 'SL6-39',
            rare        : 'SR',
            name        : 'ロイヤルファーリーフトップス',
            imgUrl      : '/images/items/SL6-39.png',
            kind        : 'トップス',
            color       : '白',
            brand       : '',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ファララチャンネル',
            id          : 'SL6-40',
            rare        : 'SR',
            name        : 'ロイヤルファーリーフスカート',
            imgUrl      : '/images/items/SL6-40.png',
            kind        : 'ボトムス',
            color       : '緑',
            brand       : '',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ファララチャンネル',
            id          : 'SL6-41',
            rare        : 'SR',
            name        : 'ロイヤルファーリーフシューズ',
            imgUrl      : '/images/items/SL6-41.png',
            kind        : 'シューズ',
            color       : '緑',
            brand       : '',
            type        : 'CO',
            point       : 600,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ファララチャンネル',
            id          : 'SL6-42',
            rare        : 'SR',
            name        : 'ロイヤルファーリーフヘアアクセ',
            imgUrl      : '/images/items/SL6-42.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : '',
            type        : 'CO',
            point       : 600,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'ファララチャンネル',
            id          : 'SL6-61',
            rare        : 'SR',
            name        : 'クロックモダンホワイトグリーンヘアアクセ',
            imgUrl      : '/images/items/SL6-61.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : '',
            type        : 'CO',
            point       : 600,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ファララチャンネル',
          }),
          item({
            collection  : 'ファララチャンネル',
          }),
          item({
            collection  : 'ファララチャンネル',
          }),


          // [NOTE] ガァララチャンネル
          // ================================================================================

          item({
            collection  : 'ガァララチャンネル',
            id          : 'SL6-43',
            rare        : 'SR',
            name        : 'アイドルウォッチタンザナイトワンピ',
            imgUrl      : '/images/items/SL6-43.png',
            kind        : 'ワンピース',
            color       : '黒',
            brand       : '',
            type        : 'PR',
            point       : 1200,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ガァララチャンネル',
            id          : 'SL6-44',
            rare        : 'SR',
            name        : 'アイドルウォッチタンザナイトシューズ',
            imgUrl      : '/images/items/SL6-44.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : '',
            type        : 'PR',
            point       : 600,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ガァララチャンネル',
            id          : 'SL6-45',
            rare        : 'SR',
            name        : 'アイドルウォッチタンザナイトヘアアクセ',
            imgUrl      : '/images/items/SL6-45.png',
            kind        : 'ヘアアクセ',
            color       : '黒',
            brand       : '',
            type        : 'PR',
            point       : 600,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ガァララチャンネル',
          }),


          item({
            collection  : 'ガァララチャンネル',
            id          : 'SL6-46',
            rare        : 'SR',
            name        : 'ロイヤルファーサルビアトップス',
            imgUrl      : '/images/items/SL6-46.png',
            kind        : 'トップス',
            color       : '黒',
            brand       : '',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ガァララチャンネル',
            id          : 'SL6-47',
            rare        : 'SR',
            name        : 'ロイヤルファーサルビアスカート',
            imgUrl      : '/images/items/SL6-47.png',
            kind        : 'ボトムス',
            color       : '青',
            brand       : '',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ガァララチャンネル',
            id          : 'SL6-48',
            rare        : 'SR',
            name        : 'ロイヤルファーサルビアシューズ',
            imgUrl      : '/images/items/SL6-48.png',
            kind        : 'シューズ',
            color       : '青',
            brand       : '',
            type        : 'CO',
            point       : 600,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ガァララチャンネル',
            id          : 'SL6-49',
            rare        : 'SR',
            name        : 'ロイヤルファーサルビアヘアアクセ',
            imgUrl      : '/images/items/SL6-49.png',
            kind        : 'ヘアアクセ',
            color       : '黒',
            brand       : '',
            type        : 'CO',
            point       : 600,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'ガァララチャンネル',
            id          : 'SL6-65',
            rare        : 'SR',
            name        : 'クロックモダンネイビーブラックヘアアクセ',
            imgUrl      : '/images/items/SL6-65.png',
            kind        : 'ヘアアクセ',
            color       : '黒',
            brand       : '',
            type        : 'PR',
            point       : 600,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ガァララチャンネル',
          }),
          item({
            collection  : 'ガァララチャンネル',
          }),
          item({
            collection  : 'ガァララチャンネル',
          }),


          // [NOTE] ファララ＆ガァララチャンネル
          // ================================================================================

          item({
            collection  : 'ファララ＆ガァララチャンネル',
            id          : 'SL6-50',
            rare        : 'SR',
            name        : 'タイムガーデンブルーミングトップス',
            imgUrl      : '/images/items/SL6-50.png',
            kind        : 'トップス',
            color       : '白',
            brand       : '',
            type        : 'PR',
            point       : 650,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ファララ＆ガァララチャンネル',
            id          : 'SL6-51',
            rare        : 'SR',
            name        : 'タイムガーデンブルーミングスカート',
            imgUrl      : '/images/items/SL6-51.png',
            kind        : 'ボトムス',
            color       : '白',
            brand       : '',
            type        : 'PR',
            point       : 700,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ファララ＆ガァララチャンネル',
            id          : 'SL6-52',
            rare        : 'SR',
            name        : 'タイムガーデンブルーミングシューズ',
            imgUrl      : '/images/items/SL6-52.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : '',
            type        : 'PR',
            point       : 600,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ファララ＆ガァララチャンネル',
            id          : 'SL6-53',
            rare        : 'SR',
            name        : 'タイムガーデンブルーミングヘアアクセ',
            imgUrl      : '/images/items/SL6-53.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : '',
            type        : 'PR',
            point       : 600,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'ファララ＆ガァララチャンネル',
            id          : 'SL6-54',
            rare        : 'SR',
            name        : 'タイムガーデンファンタスティックトップス',
            imgUrl      : '/images/items/SL6-54.png',
            kind        : 'トップス',
            color       : '黒',
            brand       : '',
            type        : 'PR',
            point       : 700,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ファララ＆ガァララチャンネル',
            id          : 'SL6-55',
            rare        : 'SR',
            name        : 'タイムガーデンファンタスティックスカート',
            imgUrl      : '/images/items/SL6-55.png',
            kind        : 'ボトムス',
            color       : '黒',
            brand       : '',
            type        : 'PR',
            point       : 650,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ファララ＆ガァララチャンネル',
            id          : 'SL6-56',
            rare        : 'SR',
            name        : 'タイムガーデンファンタスティックシューズ',
            imgUrl      : '/images/items/SL6-56.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : '',
            type        : 'PR',
            point       : 600,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ファララ＆ガァララチャンネル',
            id          : 'SL6-57',
            rare        : 'SR',
            name        : 'タイムガーデンファンタスティックヘアアクセ',
            imgUrl      : '/images/items/SL6-57.png',
            kind        : 'ヘアアクセ',
            color       : '黒',
            brand       : '',
            type        : 'PR',
            point       : 600,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'ファララ＆ガァララチャンネル',
            id          : 'SL6-58',
            rare        : 'SR',
            name        : 'クロックモダンホワイトグリーントップス',
            imgUrl      : '/images/items/SL6-58.png',
            kind        : 'トップス',
            color       : '白',
            brand       : '',
            type        : 'PR',
            point       : 650,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ファララ＆ガァララチャンネル',
            id          : 'SL6-59',
            rare        : 'SR',
            name        : 'クロックモダンホワイトグリーンスカート',
            imgUrl      : '/images/items/SL6-59.png',
            kind        : 'ボトムス',
            color       : '白',
            brand       : '',
            type        : 'PR',
            point       : 600,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ファララ＆ガァララチャンネル',
            id          : 'SL6-60',
            rare        : 'SR',
            name        : 'クロックモダンホワイトグリーンシューズ',
            imgUrl      : '/images/items/SL6-60.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : '',
            type        : 'PR',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ファララ＆ガァララチャンネル',
          }),


          item({
            collection  : 'ファララ＆ガァララチャンネル',
            id          : 'SL6-62',
            rare        : 'SR',
            name        : 'クロックモダンネイビーブラックトップス',
            imgUrl      : '/images/items/SL6-62.png',
            kind        : 'トップス',
            color       : '黒',
            brand       : '',
            type        : 'PR',
            point       : 700,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ファララ＆ガァララチャンネル',
            id          : 'SL6-63',
            rare        : 'SR',
            name        : 'クロックモダンネイビーブラックスカート',
            imgUrl      : '/images/items/SL6-63.png',
            kind        : 'ボトムス',
            color       : '黒',
            brand       : '',
            type        : 'PR',
            point       : 600,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ファララ＆ガァララチャンネル',
            id          : 'SL6-64',
            rare        : 'SR',
            name        : 'クロックモダンネイビーブラックシューズ',
            imgUrl      : '/images/items/SL6-64.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : '',
            type        : 'PR',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ファララ＆ガァララチャンネル',
          }),


          // [NOTE] あいらとアンジュセレクション
          // ================================================================================

          item({
            collection  : 'あいらとアンジュセレクション',
            id          : 'SL6-01',
            rare        : 'PR',
            name        : 'パラダイスドレス',
            imgUrl      : '/images/items/SL6-01.png',
            kind        : 'ワンピース',
            color       : '白',
            brand       : '',
            type        : 'PR',
            point       : 1610,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'あいらとアンジュセレクション',
            id          : 'SL6-02',
            rare        : 'PR',
            name        : 'パラダイスシューズ',
            imgUrl      : '/images/items/SL6-02.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : '',
            type        : 'PR',
            point       : 750,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'あいらとアンジュセレクション',
            id          : 'SL6-03',
            rare        : 'PR',
            name        : 'パラダイスティアラ',
            imgUrl      : '/images/items/SL6-03.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : '',
            type        : 'PR',
            point       : 750,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'あいらとアンジュセレクション',
            rare        : 'PR',
          }),


          item({
            collection  : 'あいらとアンジュセレクション',
            id          : 'SL6-04',
            rare        : 'PR',
            name        : 'スターリィライトパープルトップス',
            imgUrl      : '/images/items/SL6-04.png',
            kind        : 'トップス',
            color       : '紫',
            brand       : '',
            type        : 'CO',
            point       : 850,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'あいらとアンジュセレクション',
            id          : 'SL6-05',
            rare        : 'PR',
            name        : 'スターリィライトパープルスカート',
            imgUrl      : '/images/items/SL6-05.png',
            kind        : 'ボトムス',
            color       : '紫',
            brand       : '',
            type        : 'CO',
            point       : 800,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'あいらとアンジュセレクション',
            id          : 'SL6-06',
            rare        : 'PR',
            name        : 'スターリィライトパープルシューズ',
            imgUrl      : '/images/items/SL6-06.png',
            kind        : 'シューズ',
            color       : '紫',
            brand       : '',
            type        : 'CO',
            point       : 750,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'あいらとアンジュセレクション',
            id          : 'SL6-07',
            rare        : 'PR',
            name        : 'スターリィライトパープルヘアアクセ',
            imgUrl      : '/images/items/SL6-07.png',
            kind        : 'ヘアアクセ',
            color       : '紫',
            brand       : '',
            type        : 'CO',
            point       : 750,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'あいらとアンジュセレクション',
            id          : 'SL6-08',
            rare        : 'SR',
            name        : 'ピュアプレミアムウエディング',
            imgUrl      : '/images/items/SL6-08.png',
            kind        : 'ワンピース',
            color       : '白',
            brand       : '',
            type        : 'PR',
            point       : 1200,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'あいらとアンジュセレクション',
            id          : 'SL6-09',
            rare        : 'SR',
            name        : 'ピュアプレミアムハイヒール',
            imgUrl      : '/images/items/SL6-09.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : '',
            type        : 'PR',
            point       : 600,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'あいらとアンジュセレクション',
            rare        : 'SR',
          }),
          item({
            collection  : 'あいらとアンジュセレクション',
            rare        : 'SR',
          }),


          item({
            collection  : 'あいらとアンジュセレクション',
            id          : 'SL6-10',
            rare        : 'SR',
            name        : 'クリスタルスノープリンセストップス',
            imgUrl      : '/images/items/SL6-10.png',
            kind        : 'トップス',
            color       : '水',
            brand       : '',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'あいらとアンジュセレクション',
            id          : 'SL6-11',
            rare        : 'SR',
            name        : 'クリスタルスノープリンセススカート',
            imgUrl      : '/images/items/SL6-11.png',
            kind        : 'ボトムス',
            color       : '水',
            brand       : '',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'あいらとアンジュセレクション',
            id          : 'SL6-12',
            rare        : 'SR',
            name        : 'クリスタルスノープリンセスブーツ',
            imgUrl      : '/images/items/SL6-12.png',
            kind        : 'シューズ',
            color       : '水',
            brand       : '',
            type        : 'LO',
            point       : 600,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'あいらとアンジュセレクション',
            id          : 'SL6-13',
            rare        : 'SR',
            name        : 'クリスタルスノーヘアアクセ',
            imgUrl      : '/images/items/SL6-13.png',
            kind        : 'ヘアアクセ',
            color       : '水',
            brand       : '',
            type        : 'LO',
            point       : 600,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'あいらとアンジュセレクション',
            id          : 'SL6-14',
            rare        : 'SR',
            name        : 'トライアングルクーレストワンピ',
            imgUrl      : '/images/items/SL6-14.png',
            kind        : 'ワンピース',
            color       : '紫',
            brand       : '',
            type        : 'CO',
            point       : 1200,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'あいらとアンジュセレクション',
            id          : 'SL6-15',
            rare        : 'SR',
            name        : 'トライアングルクーレストシューズ',
            imgUrl      : '/images/items/SL6-15.png',
            kind        : 'シューズ',
            color       : '紫',
            brand       : '',
            type        : 'CO',
            point       : 600,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'あいらとアンジュセレクション',
            id          : 'SL6-16',
            rare        : 'SR',
            name        : 'トライアングルクーレストヘアアクセ',
            imgUrl      : '/images/items/SL6-16.png',
            kind        : 'ヘアアクセ',
            color       : '紫',
            brand       : '',
            type        : 'CO',
            point       : 600,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'あいらとアンジュセレクション',
            rare        : 'SR',
          }),


          item({
            collection  : 'あいらとアンジュセレクション',
            id          : 'SL6-17',
            rare        : 'SR',
            name        : 'じゅんぱくのつばさトップス',
            imgUrl      : '/images/items/SL6-17.png',
            kind        : 'トップス',
            color       : '白',
            brand       : '',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'あいらとアンジュセレクション',
            id          : 'SL6-18',
            rare        : 'SR',
            name        : 'じゅんぱくのつばさスカート',
            imgUrl      : '/images/items/SL6-18.png',
            kind        : 'ボトムス',
            color       : '白',
            brand       : '',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'あいらとアンジュセレクション',
            id          : 'SL6-19',
            rare        : 'SR',
            name        : 'じゅんぱくのつばさシューズ',
            imgUrl      : '/images/items/SL6-19.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : '',
            type        : 'LO',
            point       : 600,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'あいらとアンジュセレクション',
            id          : 'SL6-20',
            rare        : 'SR',
            name        : 'じゅんぱくのつばさヘアアクセ',
            imgUrl      : '/images/items/SL6-20.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : '',
            type        : 'LO',
            point       : 600,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'あいらとアンジュセレクション',
            id          : 'SL6-21',
            rare        : 'R',
            name        : 'フレッシュピンクベアトップ',
            imgUrl      : '/images/items/SL6-21.png',
            kind        : 'トップス',
            color       : '桃',
            brand       : '',
            type        : 'PR',
            point       : 550,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'あいらとアンジュセレクション',
            id          : 'SL6-22',
            rare        : 'R',
            name        : 'フレッシュピンクパニエ',
            imgUrl      : '/images/items/SL6-22.png',
            kind        : 'ボトムス',
            color       : '桃',
            brand       : '',
            type        : 'PR',
            point       : 450,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'あいらとアンジュセレクション',
            id          : 'SL6-23',
            rare        : 'R',
            name        : 'フレッシュピンクブーツ',
            imgUrl      : '/images/items/SL6-23.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : '',
            type        : 'PR',
            point       : 500,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'あいらとアンジュセレクション',
            rare        : 'R',
          }),


          item({
            collection  : 'あいらとアンジュセレクション',
            id          : 'SL6-24',
            rare        : 'R',
            name        : 'シャイニーリボンベスト',
            imgUrl      : '/images/items/SL6-24.png',
            kind        : 'トップス',
            color       : '桃',
            brand       : '',
            type        : 'PR',
            point       : 550,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'あいらとアンジュセレクション',
            id          : 'SL6-25',
            rare        : 'R',
            name        : 'シャイニーリボンスカート',
            imgUrl      : '/images/items/SL6-25.png',
            kind        : 'ボトムス',
            color       : '桃',
            brand       : '',
            type        : 'PR',
            point       : 500,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'あいらとアンジュセレクション',
            id          : 'SL6-26',
            rare        : 'R',
            name        : 'ラインリボンロングブーツ',
            imgUrl      : '/images/items/PAF01-13.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : '',
            type        : 'PR',
            point       : 450,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'あいらとアンジュセレクション',
            id          : 'SL6-27',
            rare        : 'R',
            name        : 'ハピラキヘアアクセ',
            imgUrl      : '/images/items/SL6-27.png',
            kind        : 'ヘアアクセ',
            color       : '黒',
            brand       : '',
            type        : 'PR',
            point       : 450,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'あいらとアンジュセレクション',
            id          : 'SL6-28',
            rare        : 'R',
            name        : 'もぎたてオレンジパーカ',
            imgUrl      : '/images/items/SL6-28.png',
            kind        : 'トップス',
            color       : '橙',
            brand       : '',
            type        : 'PO',
            point       : 550,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'あいらとアンジュセレクション',
            id          : 'SL6-29',
            rare        : 'R',
            name        : 'もぎたてオレンジパンツ',
            imgUrl      : '/images/items/SL6-29.png',
            kind        : 'ボトムス',
            color       : '橙',
            brand       : '',
            type        : 'PO',
            point       : 500,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'あいらとアンジュセレクション',
            id          : 'SL6-30',
            rare        : 'R',
            name        : 'もぎたてオレンジシューズ',
            imgUrl      : '/images/items/SL6-30.png',
            kind        : 'シューズ',
            color       : '橙',
            brand       : '',
            type        : 'PO',
            point       : 450,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'あいらとアンジュセレクション',
            id          : 'SL6-31',
            rare        : 'R',
            name        : 'もぎたてオレンジヘアアクセ',
            imgUrl      : '/images/items/SL6-31.png',
            kind        : 'ヘアアクセ',
            color       : '橙',
            brand       : '',
            type        : 'PO',
            point       : 450,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'あいらとアンジュセレクション',
            id          : 'SL6-32',
            rare        : 'R',
            name        : 'リトルローズきらびやかトップス',
            imgUrl      : '/images/items/SL6-32.png',
            kind        : 'トップス',
            color       : '水',
            brand       : '',
            type        : 'LO',
            point       : 450,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'あいらとアンジュセレクション',
            id          : 'SL6-33',
            rare        : 'R',
            name        : 'リトルローズきらびやかスカート',
            imgUrl      : '/images/items/SL6-33.png',
            kind        : 'ボトムス',
            color       : '水',
            brand       : '',
            type        : 'LO',
            point       : 550,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'あいらとアンジュセレクション',
            id          : 'SL6-34',
            rare        : 'R',
            name        : 'リトルローズきらびやかシューズ',
            imgUrl      : '/images/items/SL6-34.png',
            kind        : 'シューズ',
            color       : '水',
            brand       : '',
            type        : 'LO',
            point       : 500,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'あいらとアンジュセレクション',
            id          : 'SL6-35',
            rare        : 'R',
            name        : 'リトルローズきらびやかヘアアクセ',
            imgUrl      : '/images/items/SL6-35.png',
            kind        : 'ヘアアクセ',
            color       : '水',
            brand       : '',
            type        : 'LO',
            point       : 450,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
        ],
      }
    },

    computed: {
      itemsFiltered () {
        const { excepts, items } = this
        return excepts.length
          ? items.filter(item => !excepts.includes(item.collection) )
          : items
      },

      itemsMaJor () {
        const { major, itemsFiltered, itemsPasha } = this
        return itemsFiltered.filter(item => major.includes(item.collection) && !itemsPasha.includes(item))
      },

      itemsKR () {
        return _.where(this.itemsMaJor, { rare: 'KR' })
      },

      itemsPR () {
        return _.where(this.itemsMaJor, { rare: 'PR' })
      },

      itemsSR () {
        return _.where(this.itemsMaJor, { rare: 'SR' })
      },

      itemsR () {
        return _.where(this.itemsMaJor, { rare: 'R' })
      },

      itemsN () {
        return _.where(this.itemsMaJor, { rare: 'N' })
      },

      itemsPasha () {
        return _.where(this.itemsFiltered, { kind: 'パシャッとアイテム' }).filter(item => this.major.includes(item.collection) )
      },

      itemsNakayoshiChannel () {
        return _.where(this.itemsFiltered, { collection: 'なかよしチャンネル' })
      },

      itemsMolly () {
        return _.where(this.itemsFiltered, { collection: 'モーリーファンタジー限定' })
      },

      itemsMikuKuma () {
        return _.where(this.itemsFiltered, { collection: '初音ミク復刻コラボ・リラックマコラボ' })
      },

      itemsValentine () {
        return _.where(this.itemsFiltered, { collection: 'バレンタインキャンペーン' })
      },

      itemsWhiteday () {
        return _.where(this.itemsFiltered, { collection: 'ホワイトデーキャンペーン' })
      },

      itemsNextPrincess () {
        return _.where(this.itemsFiltered, { collection: 'ネクスト・プリンセス・スペシャル大会' })
      },

      itemsFalala () {
        return _.where(this.itemsFiltered, { collection: 'ファララチャンネル' })
      },

      itemsGaalala () {
        return _.where(this.itemsFiltered, { collection: 'ガァララチャンネル' })
      },

      itemsFalalaGaalala () {
        return _.where(this.itemsFiltered, { collection: 'ファララ＆ガァララチャンネル' })
      },

      itemsAirange () {
        return _.where(this.itemsFiltered, { collection: 'あいらとアンジュセレクション' })
      },

      itemsAirangePR () {
        return _.where(this.itemsAirange, { rare: 'PR' })
      },

      itemsAirangeSR () {
        return _.where(this.itemsAirange, { rare: 'SR' })
      },

      itemsAirangeR () {
        return _.where(this.itemsAirange, { rare: 'R' })
      },
    },
  }
</script>


<template>
  <ItemPage :items="items" :narrowCols="[]">
    <template #title>
      <PageChooser />
      <time>{{ date }}</time>
    </template>
    <template #col1>
      <ItemList title="KR ★★★★" color="#ff5d91" :items="itemsKR" />
      <ItemList title="PR ★★★" color="#ffa1bc" :items="itemsPR" />
      <ItemList title="PR モーリー限定 ★★★" color="#55b272" :items="itemsMolly" />
    </template>
    <template #col2>
      <ItemList title="SR ★★" color="#00c7da" :items="itemsSR" />
      <ItemList title="SR バレンタインキャンペーン ★★" color="#00c7da" :items="itemsValentine" />
      <ItemList title="SR ホワイトデーキャンペーン ★★" color="#00c7da" :items="itemsWhiteday" />
    </template>
    <template #col3>
      <ItemList title="R ★" color="#feab0d" :items="itemsR" />
      <ItemList title="N" color="#f6c3b2" :items="itemsN" />
    </template>
    <template #col4>
      <ItemList title="パシャッとアイテム" color="#c598ff" :items="itemsPasha" />
      <ItemList title="なかよしチャンネル" color="#c598ff" :items="itemsNakayoshiChannel" />
      <ItemList title="初音ミク復刻コラボ・リラックマコラボ" color="#a1c0fa" :items="itemsMikuKuma" />
      <ItemList title="ネクスト・プリンセス・スペシャル大会" color="#a1c0fa" :items="itemsNextPrincess" />
    </template>
    <template #col5>
      <ItemList title="ファララチャンネル" color="#a1c0fa" :items="itemsFalala" />
      <ItemList title="ガァララチャンネル" color="#a1c0fa" :items="itemsGaalala" />
      <ItemList title="ファララ＆ガァララチャンネル" color="#a1c0fa" :items="itemsFalalaGaalala" />
    </template>
    <template #col6>
      <ItemList title="あいらンジュセレクション PR" color="#ffa1bc" :items="itemsAirangePR" />
      <ItemList title="あいらンジュセレクション SR" color="#00c7da" :items="itemsAirangeSR" />
      <ItemList title="あいらンジュセレクション R" color="#feab0d" :items="itemsAirangeR" />
      <Status :date="date" :items="items" :showKira="true" :showKR="true" />
    </template>
    <template #col7>
    </template>
    <template #col8>
    </template>
    <template #col9>
    </template>
    <template #col10>
    </template>
  </ItemPage>
</template>


<style lang="scss" scoped>
  @import '~@/stylesheets/common';

  // コレクショングループ間の間隔 (KR)
  .Page ::v-deep .Page__col:nth-child(1) .ItemList:nth-child(1) {
    .Item:nth-child(5),
    .Item:nth-child(6),
    .Item:nth-child(7),
    .Item:nth-child(8) {
      margin-top: $size-unit * 8;
    }
  }

  // コレクショングループ間の間隔 (PR)
  .Page ::v-deep .Page__col:nth-child(1) .ItemList:nth-child(2) {
    .Item:nth-child(9),
    .Item:nth-child(10),
    .Item:nth-child(11),
    .Item:nth-child(12) {
      margin-top: $size-unit * 8;
    }
  }

  // コレクショングループ間の間隔 (SR)
  .Page ::v-deep .Page__col:nth-child(2) .ItemList:nth-child(1) {
    .Item:nth-child(17),
    .Item:nth-child(18),
    .Item:nth-child(19),
    .Item:nth-child(20) {
      margin-top: $size-unit * 8;
    }
  }

  // コレクショングループ間の間隔 (パシャテム)
  .Page ::v-deep .Page__col:nth-child(4) .ItemList:nth-child(1) {
    .Item:nth-child(5),
    .Item:nth-child(6),
    .Item:nth-child(7),
    .Item:nth-child(8),
    .Item:nth-child(9),
    .Item:nth-child(10),
    .Item:nth-child(11),
    .Item:nth-child(12) {
      margin-top: $size-unit * 8;
    }
  }

  // PC View: ステータスの表示位置を調整
  .Page ::v-deep .Status {
    // PC View のとき position: absolute になっている (see: ItemPage.vue)
    bottom: 0;
    left: 0;
  }

  // PC View: ステータス表示を置く空間を確保
  @include iroha-vw-range($from: strip-unit($device-width--pc), $also-apply: print) {
    .Page ::v-deep .Page__body {
      padding-bottom: $size-unit * 60;
    }
  }
</style>
